module.exports = __webpack_public_path__ + "static/media/TH.400974b1.svg";